import { isOTCForwardSecurity, isOTCOptionSecurity } from '../../../../types/OTC/otcSecurityTypeGuards';
import type { Security } from '../../../../types/Security';
import { ProductTypeEnum } from '../../../../types/types';
import { isNonEmpty } from '../../../../utils/string';
import type { StrikeFwdPriceValue } from './strikeFwdPriceValue';

/** Strike / forward display value from SecMaster security lookup (Sub Accounts / PMS blotters). */
export function getStrikePriceValueFromSecurity(security: Security | undefined): StrikeFwdPriceValue | undefined {
  if (!security) {
    return undefined;
  }

  if (isOTCForwardSecurity(security)) {
    const forwardPrice = security.ProductDetails.ForwardPrice;
    if (!isNonEmpty(forwardPrice)) {
      return undefined;
    }
    return {
      type: 'number',
      value: forwardPrice,
      currency: security.ProductDetails.QuoteAsset,
    };
  }

  if (isOTCOptionSecurity(security)) {
    const { StrikePrice, StrikePriceCcy, StrikeDelta } = security.ProductDetails;
    if (isNonEmpty(StrikePrice)) {
      const currency = StrikePriceCcy?.trim() || 'USD';
      return { type: 'number', value: StrikePrice, currency };
    }
    if (isNonEmpty(StrikeDelta)) {
      return { type: 'text', value: `${String(StrikeDelta).trim()}D` };
    }
    return undefined;
  }

  if (security.ProductType === ProductTypeEnum.Option && isNonEmpty(security.StrikePrice)) {
    return {
      type: 'number',
      value: security.StrikePrice,
      currency: security.UnderlyingQuoteCurrency,
    };
  }

  return undefined;
}
